<template>
  <div class="app-section" style="height: 100%; min-height: 100%;">
    <login-view v-if="notLogin" v-show="loginSettle" v-cloak></login-view>

    <div class="layout" v-else>
      <el-container style="height: 100%; min-height: 100%;">
        <el-aside width="200px" class="layout-menu-left">
          <side-menu :permissions="permissions"></side-menu>
        </el-aside>

        <el-container>
          <el-header class="layout-header">
            <el-row>
              <el-col :span="22">&nbsp;</el-col>
              <el-col :span="2" class="top-menu-section">
                <top-menu></top-menu>
              </el-col>
            </el-row>
          </el-header>

          <navigator></navigator>

          <el-main>
            <div class="error-wrapper" v-if="errorMessage && errorMessage.length">
              <el-alert
                :title="errorMessage"
                type="warning"
                show-icon
                :closable="false">
              </el-alert>
            </div>
            <router-view></router-view>
          </el-main>

          <el-footer class="layout-copy">test</el-footer>
        </el-container>
      </el-container>
    </div>
  </div>
</template>

<script>
import SideMenu from '@/components/layout/SideMenu';
import Navigator from '@/components/layout/Navigator';
import TopMenu from '@/components/layout/TopMenu';
import Login from '@/components/Login';
import constant from '@/constant';

export default {
  data() {
    return {
      errorMessage: '',
      loginSettle: false
    };
  },
  computed: {
    permissions() {
      const permissionArr = this.$store.state.user.permissions || [];
      const result = {};
      permissionArr.forEach((permission) => {
        result[permission] = {
          name: permission,
          menuName: constant.permissionMenuMap[permission] || 'unknown menu'
        };
      });
      return result;
    },
    notLogin() {
      let result = true;
      if (this.$store.state.user && this.$store.state.user.userInfo) {
        result = false;
      }
      return result;
    }
  },
  created() {
    this.$http.get('sessions').then((res) => {
      this.loginSettle = true;
      const data = res.data ? res.data.data[0] : null;
      if (data && data.id && data.username) {
        this.$store.commit('updateUser', data);
        this.$router.replace('dashboard');
      } else {
        this.$store.commit('clearUser');
      }
    }).catch(() => {
      this.loginSettle = true;
      this.$store.commit('clearUser');
    });
  },
  components: {
    'login-view': Login,
    'side-menu': SideMenu,
    'navigator': Navigator,
    'top-menu': TopMenu
  }
};
</script>

<style scoped>
.error-wrapper {
  z-index: 1;
  position: absolute;
  width: 100%;
}

.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  height: 100%;
  min-height: 100%;
}

.layout-header {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
  padding: 0;
}

.top-menu-section {
  padding-top: 15px;
}

.layout-menu-left {
  background: #464c5b;
  color: #fff;
}

.layout-copy {
  text-align: center;
  padding: 20px 0;
  color: #9ea7b4;
}
</style>



// WEBPACK FOOTER //
// src/App.vue